import Legend from "./Legend/index.js"; // eslint-disable-next-line @typescript-eslint/no-explicit-any
import { jsx as _jsx } from "react/jsx-runtime";
/** Ordinal scales map from strings to an Output type. */
export default function Ordinal(props) {
  return /*#__PURE__*/_jsx(Legend, {
    ...props
  });
}